import PreviewPaneSelectionSource from './PreviewPaneSelectionSource';
import { AttachmentPreviewMethod } from 'owa-attachment-data';
import { ClientAttachmentId } from 'owa-client-ids';

export enum SaveToCloudStatus {
    disabled,
    available,
    saving,
    succeeded,
    failed,
}

interface SxSExtendedViewState {
    previewMode: AttachmentPreviewMethod;
    attachmentId: ClientAttachmentId;
    selectionSource: PreviewPaneSelectionSource;
    isCloudy: boolean;
    saveToCloudStatus: SaveToCloudStatus;
}

export default SxSExtendedViewState;
